// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1LWNx","author":"Table_author__3G3aa","authorImage":"Table_authorImage__1EhcI","unreadRow":"Table_unreadRow__r1orS"};